import { render } from "./Attack.vue?vue&type=template&id=37100ea4&scoped=true"
import script from "./Attack.vue?vue&type=script&lang=js"
export * from "./Attack.vue?vue&type=script&lang=js"

import "./Attack.vue?vue&type=style&index=0&id=37100ea4&scoped=true&lang=scss"

import exportComponent from "/Users/adamklemm/vues/pmp/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-37100ea4"]])

export default __exports__